/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-04 16:22:41
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 18:38:19
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SiderErrorController/tools.ts
 */
import { dispatch, getState } from 'src/store';
import {
  //fetchSalesChannelSiderError,
  fetchSalesChannelContentSiderError,
  fetchSalesChannelProductSiderError,
  getErrorState,
} from './slice';

const _generateApi = ({ uuid, forceUpdate, update }) => {
  if (forceUpdate) {
    update();
  } else {
    const state = getState();
    const data = getErrorState(uuid)(state);
    if (!data) {
      update();
    }
  }

  // const currentUuid = getErrorStateUuid()(state);
  // if (uuid !== currentUuid) {
  //   dispatch(fetchSiderError({ uuid }));
  // }
};

const updateSalesChannel = ({ uuid, forceUpdate = true }) => {
  _generateApi({
    uuid,
    forceUpdate,
    update: () => {
      // dispatch(fetchSalesChannelSiderError({ salesChannelUuid: uuid }));
    },
  });
};

const updateSalesChannelContent = ({
  uuid,
  contentUuid,
  forceUpdate = true,
}) => {
  _generateApi({
    uuid,
    forceUpdate,
    update: () => {
      dispatch(
        fetchSalesChannelContentSiderError({
          contentUuid,
          salesChannelUuid: uuid,
        }),
      );
    },
  });
};

const updateSalesChannelProduct = ({
  uuid,
  productUuid,
  forceUpdate = true,
}) => {
  _generateApi({
    uuid,
    forceUpdate,
    update: () => {
      dispatch(
        fetchSalesChannelProductSiderError({
          productUuid,
          salesChannelUuid: uuid,
        }),
      );
    },
  });
};

export {
  updateSalesChannel,
  updateSalesChannelContent,
  updateSalesChannelProduct,
};
